module.exports = __webpack_public_path__ + "img/shareIcon.a06e5daf.svg";